export default {"src":"/_next/static/media/driveway.6722096a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};